import { render, staticRenderFns } from "./Dice.vue?vue&type=template&id=7372c235&scoped=true"
import script from "./Dice.vue?vue&type=script&lang=js"
export * from "./Dice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7372c235",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7372c235')) {
      api.createRecord('7372c235', component.options)
    } else {
      api.reload('7372c235', component.options)
    }
    module.hot.accept("./Dice.vue?vue&type=template&id=7372c235&scoped=true", function () {
      api.rerender('7372c235', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/components/Dice.vue"
export default component.exports